import { render, staticRenderFns } from "./BandSwiper.vue?vue&type=template&id=60420fc2&"
import script from "./BandSwiper.vue?vue&type=script&lang=js&"
export * from "./BandSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BandSwiper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports